module.exports = __webpack_public_path__ + "img/chat-icon05.4a6fe00a.png";